import { createRouter, createWebHistory  } from 'vue-router';
import systemRoutes from "@/router/system/routes";
import UserManagment from "@/views/pages/UserManagment.vue";
import UserManagmentAdditional from "@/views/pages/UserManagmentAdditional.vue";
import FormReports from "@/views/pages/FormReports.vue";
import PlantManagment from "@/views/pages/PlantManagment.vue";
import ProviderManagment from "@/views/pages/ProviderManagment.vue";
import ProviderDetails from "@/views/pages/ProviderDetails.vue";
import SettingsManagment from "@/views/pages/SettingsManagment.vue";
import hideError from "@/router/system/middleware/hideError";
import closeModals from "@/router/system/middleware/closeModals";
import changeTitle from "@/router/middleware/changeTitle";
import resetFooterCounter from "@/router/system/middleware/resetFooterCounter";
import checkToken from "@/router/system/middleware/checkToken";
import checkPermissionForRoute from "@/router/system/middleware/checkPermission";


const routes = [
  {
    path: '/users',
    name: 'Users',
    components: {
      default: UserManagment,
      LeftSidebar: () => import('@/components/Sidebar.vue'),
    },
    meta: {
      middleware: [hideError, closeModals, changeTitle, resetFooterCounter, checkToken, checkPermissionForRoute],
    }
  },
  {
    path: '/usersAdditional',
    name: 'UsersAdditional',
    components: {
      default: UserManagmentAdditional,
      LeftSidebar: () => import('@/components/Sidebar.vue'),
    },
    meta: {
      middleware: [hideError, closeModals, changeTitle, resetFooterCounter, checkToken],
    }
  },
  {
    path: '/forms/reports',
    name: 'FormReports',
    components: {
      default: FormReports,
      LeftSidebar: () => import('@/components/Sidebar.vue'),
    },
    meta: {
      middleware: [hideError, closeModals, changeTitle, resetFooterCounter, checkToken, checkPermissionForRoute],
    }
  },
  {
    path: '/plants',
    name: 'PlantManagment',
    components: {
      default: PlantManagment,
      LeftSidebar: () => import('@/components/Sidebar.vue'),
    },
    meta: {
      middleware: [hideError, closeModals, changeTitle, resetFooterCounter, checkToken, checkPermissionForRoute],
    }
  },
  {
    path: '/providers',
    name: 'ProviderManagment',
    components: {
      default: ProviderManagment,
      LeftSidebar: () => import('@/components/Sidebar.vue'),
    },
    meta: {
      middleware: [hideError, closeModals, changeTitle, resetFooterCounter, checkToken, checkPermissionForRoute],
    }
  },
  {
    path: '/providers/:id([0-9a-f]{8}[-]?[0-9a-f]{4}[-]?[0-9a-f]{4}[-]?[0-9a-f]{4}[-]?[0-9a-f]{12})',
    name: 'ProviderDetails',
    components: {
      default: ProviderDetails,
      LeftSidebar: () => import('@/components/Sidebar.vue'),
    },
    meta: {
      middleware: [hideError, closeModals, changeTitle, resetFooterCounter, checkToken, checkPermissionForRoute],
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    components: {
      default: SettingsManagment,
      LeftSidebar: () => import('@/components/Sidebar.vue'),
    },
    meta: {
      middleware: [hideError, closeModals, changeTitle, resetFooterCounter, checkToken, checkPermissionForRoute],
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...systemRoutes,
    ...routes
  ],
})


/*--- MIDDLEWARE IMPLEMENTATION ---*/


function middlewarePipeline (context:any, middleware:any, index:any) {
  const nextMiddleware = middleware[index]

  if(!nextMiddleware){
    return context.next
  }

  return () => {
    const nextPipeline = middlewarePipeline(
        context, middleware, index + 1
    )

    nextMiddleware({ ...context, next: nextPipeline })

  }
}


router.beforeEach((to, from, next) => {

  /** Navigate to next if middleware is not applied */
  if (!to.meta.middleware) {
    return next()
  }

  const middleware:any = to.meta.middleware;
  const context = {
    to,
    from,
    next,
    //   store  | You can also pass store as an argument
  }

  return middleware[0]({
    ...context,
    next:middlewarePipeline(context, middleware,1)
  })
})

export default router;
